module.exports = __webpack_public_path__ + "static/img/vFive2.16f995b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vFive2.png
// module id = j61j
// module chunks = 2